<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <div class="paddingContent">
      <div class="ListMenu">
        <el-form ref="form" :model="listMenuForm" class="searchForm">

          <el-form-item label="帖子id：" class="searchItem">
              <el-input v-model="listMenuForm.postId" @change="listMenuForm.postId = listMenuForm.postId.replace(/\D/g,'')"></el-input>
          </el-form-item>

          <el-form-item label="帖子標題：" class="searchItem">
              <el-input v-model="listMenuForm.postTitle"></el-input>
            </el-form-item>

          <el-form-item label="開始時間："  class="searchItem ">
            <el-date-picker v-model="listMenuForm.startTime" type="datetime"  placeholder="選擇時間"></el-date-picker>
          </el-form-item>

          <el-form-item label="結束時間："  class="searchItem hidden-md-and-down">
            <el-date-picker v-model="listMenuForm.endTime" type="datetime" placeholder="選擇時間"></el-date-picker>
          </el-form-item>
        </el-form>

      </div>
      <div class="ListMenu">
        <el-form ref="form" :model="listMenuForm" class="searchForm">
          <el-form-item label="結束時間："  class="searchItem hidden-lg-and-up">
            <el-date-picker v-model="listMenuForm.endTime" type="datetime" placeholder="選擇時間"></el-date-picker>
          </el-form-item>
        </el-form>

      </div>
      <div class="MenuBtnWrap">
        <div class="btn" @click="search()">查詢</div>
        <div class="btn borderBtn" @click="reset()">重置</div>
      </div>
      <div class="tableWrap">
        <el-table height='660px' stripe :data="postList" style="width:100%;">
          <template slot="empty">
            <div class="no-data-container">
              <img src="@/assets/images/common/no_data.png" alt="暂无数据" :style="{width:'244px',height:'139px'}">
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in postTable" :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width">
          </el-table-column>
          <el-table-column
            label="操作"
            width='140'
            fixed="right">
            <template slot-scope="scope">
              <el-button @click="toEditSubject(scope.row.id,)" type="text" >詳情</el-button>
              <el-button @click="delSubject(scope.row.id,)" type="text" >刪除</el-button>
              <el-button @click="toComment(scope.row.id)" type="text" >評論</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count='5'
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';
export default {
  data () {
    return {
      navBlock:'社區',
      navtitle:'帖子列表',
      listMenuForm:{
        postId: '',
        postTitle: '',
        startTime: '',
        endTime: '',
      },

      postList:[],
      postTable: [
        {
          prop: 'id',
          label: '帖子id',
          width: '140'
        }, {
          prop: 'title',
          label: '標題',
          width: ''
        }, {
          prop: 'pageView',
          label: '瀏覽量',
          width: '110'
        }, {
          prop: 'likeNum',
          label: '點讚數量',
          width: '110'
        }, {
          prop: 'commentNum',
          label: '評論數量',
          width: '110'
        }, {
          prop: 'createDate',
          label: '發佈時間',
          width: '140'
        }
      ],
      currentPage: 1, // 分页
      total: 0,
      dialogVisible: false,
    }
  },
  created(){
    this.getPostList();
  },
  mounted(){
    if (window.history && window.history.pushState) {
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', this.goBack, false);
    }
  },
  activated(){
    if (this.currentPage === 1){
      this.getPostList();
    }
  },
  destroyed(){
    this.$message.closeAll();
    window.removeEventListener('popstate', this.goBack, false);
  },
  methods:{
    goBack () {
        console.log("点击了浏览器的返回按钮");
        // sessionStorage.clear();
        // window.history.back();
    },
    // 获取帖子列表信息
    getPostList(){
      let _this = this;
      let param ={
        supervisionId: _this.listMenuForm.postId,
        title: _this.listMenuForm.postTitle,
        beforeTime: (_this.listMenuForm.startTime === ''|| _this.listMenuForm.startTime === null)  ? null  : _this.$formatDate(_this.listMenuForm.startTime),
        afterTime: (_this.listMenuForm.endTime === ''|| _this.listMenuForm.endTime === null)  ? null  : _this.$formatDate(_this.listMenuForm.endTime),
        pageNo: _this.currentPage,
        pageSize: 10,
      }
      this.$post('/request/community/supervisionList', param, this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            res.data.list.forEach(v=>{
              v.createDate= this.$getTime(v.createDate)
            })
            _this.postList = res.data.list;
            _this.total = res.data.allRow;
          } else {
            this.$propMessage(res.message, 'error');
          };
        });
    },
    // 分页
    handleCurrentChange (val) {
      this.currentPage = val;
      this.getPostList();
    },
    // 删除帖子
    delSubject(id){
      let _this = this;
      _this.$confirm('是否刪除該帖子?', '提示信息', {
          confirmButtonText: '確認',
          cancelButtonText: '取消',
          center: true,
        closeOnClickModal: false
        }).then(()=> {
          // 确认删除的回调
          _this.$post(`/request/community/delStickers/stickers/${id}`, {}, _this.$GLOBAL.jsonConfig)
            .then((res) => {
              _this.dialogVisible  = true;
              if(res.code === '00000'){

                _this.$propMessage('刪除成功，請稍候', 'success',
                  function(){
                  _this.dialogVisible = false;
                  _this.currentPage = 1;
                  _this.getPostList();
                 });

              } else {
                _this.$propMessage(res.message, 'error',
                  function(){
                  _this.dialogVisible = false;
                 });
              };
          });
      });
    },
    // 进入帖子详情
    toEditSubject (id,) {
      this.$router.push(`/postDetails?id=${id}&type=details`);
    },
    reset(){
      let _this = this;
      _this.listMenuForm={
        postId: '',
        postTitle: '',
        startTime: '',
        endTime: '',
      }
      _this.currentPage = 1;
      _this.getPostList();
    },

    search(){
      let _this = this;
      if (_this.listMenuForm.postId === '' && _this.listMenuForm.postTitle === '' && _this.listMenuForm.startTime === '' && _this.listMenuForm.endTime === '') {
        _this.dialogVisible = true;
        _this.$propMessage('請輸入至少一個搜索條件','error',function(){
          _this.dialogVisible = false;
        });

        return false;
      };
      if (_this.$compareTime(_this.listMenuForm.startTime, _this.listMenuForm.endTime)) {
        _this.dialogVisible = true;
        _this.$propMessage('開始時間不可以晚於結束時間','error',function(){
          _this.dialogVisible = false;
        });
        return false;
      };
      _this.currentPage = 1;
      _this.getPostList();
    },
    // 帖子评论
    toComment(id){
      this.$router.push(`postCommentList?id=${id}`)
    },
  },
  components: {
    NavBar,
    DiaMess,
  }
};
</script>

<style lang="less" scoped>
  .content{
    .paddingContent{
      .ListMenu{
        .MenuBtnWrap{
          display: flex;
          justify-content: flex-end;
          .btn:last-child{
            margin-left: 0.2rem;
          }
        }
      }
      .tableWrap {
        width: 100%;
        height: calc(100% - 152px);
        overflow: auto;
        word-break: break-all;

        @media (max-width: 768px) {
          height: calc(100% - 92px);
        }

        @media (max-width: 420px) {
          height: calc(100% - 112px);
        }
      }
    }
    .topBtn{
      width:50px;
    }
  }
  @media screen and (min-width: 769px) {
    .ListMenu{
        display: flex;
        justify-content: space-between;
        .searchForm{
          flex: 1;
          display: flex;
          justify-content: flex-start;
        }
        .MenuBtnWrap{
          flex: 1;
        }
      }
  }
</style>




// WEBPACK FOOTER //
// src/pages/community/postList.vue